import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PendingPage from "@/pages/PendingPage";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Guest users (demo-modus + geen login) mogen door — de backend levert
    // reeds geanonimiseerde data. Redirect enkel wanneer er echt geen user is.
    if (!loading && !user) {
      navigate("/login", { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Laden…</div>
      </div>
    );
  }
  if (!user) return null;
  if (user.role === "pending" || user.role === "blocked") {
    return <PendingPage />;
  }
  return children;
}
